import { StudentProxyType } from '../../peekapak-types/DataProtocolTypes';
import { AttendanceSubmissionPayload } from '../BackendInterface';

export type AttendanceStatus = 'present' | 'absent';

export interface AttendanceDraft {
  shiftNumber: string;
  selectedSessions: string[];
  attendanceStatuses: Record<string, AttendanceStatus>;
}

/**
 * Initialises an attendance status map with every student defaulting to 'present'.
 * The map is keyed by each student's `sid`.
 */
export function initializeAttendanceStatuses(students: StudentProxyType[]): Record<string, AttendanceStatus> {
  return students.reduce<Record<string, AttendanceStatus>>((acc, student) => {
    acc[student.sid] = 'present';
    return acc;
  }, {});
}

/**
 * Counts how many students are present and absent in the given status map.
 */
export function countAttendance(statuses: Record<string, AttendanceStatus>): {
  present: number;
  absent: number;
} {
  return Object.values(statuses).reduce(
    (acc, status) => {
      if (status === 'present') {
        acc.present += 1;
      } else {
        acc.absent += 1;
      }
      return acc;
    },
    { present: 0, absent: 0 },
  );
}

/**
 * Returns the localforage key used to cache an attendance draft for a specific classroom.
 */
export function buildAttendanceCacheKey(classroomId: string): string {
  return `takween-attendance-draft-${classroomId}`;
}

/**
 * Assembles the payload object for the submitAttendance API call.
 */
export function buildSubmissionPayload(
  classroomId: string,
  unitId: string,
  shiftNumber: string,
  selectedSessions: Set<string>,
  attendanceStatuses: Record<string, AttendanceStatus>,
): AttendanceSubmissionPayload {
  return {
    classroomId,
    unitId,
    shiftNumber: parseInt(shiftNumber, 10),
    sessions: Array.from(selectedSessions),
    attendanceStatuses,
    submittedAt: Date.now(),
  };
}
